import Faq from '@/faq'
import GroupLinksAccordion from '@/group_links_accordion'

new Faq()
new GroupLinksAccordion()
